import * as React from 'react';
import PricePresentation, { IPricePresentationBase } from '../PricePresentation';
import { IVatMessage } from '@vp/vp-js-token-engine';

export default class VatMessage extends React.Component<IPricePresentationBase<IVatMessage>> {
  public render(): JSX.Element {
    return (
      <PricePresentation
        classNameWrapper={this.props.classNameWrapper}
        type="vatMessage"
        pricingInfo={this.props.pricingInfo}
        tenant={this.props.tenant}
        placeHolderText={this.props.placeHolderText}
        isTile={this.props.isTile}
      />
    );
  }
}
